import {
	requestApiGet,
	requestApiPost,
	requestApiPostNoContent,
} from "../api/BacklogApiEndpoint";
import type { BacklogConfig } from "../contracts/BacklogConfig";
import type { BacklogApiContext } from "../contracts/api/BacklogApiContext";
import type { BacklogResponse } from "../contracts/api/BacklogResponse";
import type { BacklogResponseNoContent } from "../contracts/api/BacklogResponseNoContent";
import type { NotificationCount } from "../entities/NotificationCount";
import type { NotificationUnreadCount } from "../entities/NotificationUnreadCount";
import type { UserNotification } from "../entities/UserNotification";
import { assert } from "../utils/BacklogUtil";
import type { CountNotificationParams } from "./params/CountNotificationParams";
import type { GetNotificationParams } from "./params/GetNotificationParams";
import type { ReadNotificationParams } from "./params/ReadNotificationParams";

/**
 * Get Notification お知らせ一覧の取得
 *
 * Returns own notifications.
 */
export function getNotification(
	config: BacklogConfig,
	params?: GetNotificationParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<UserNotification[]>> {
	return requestApiGet({
		config,
		path: "notifications",
		params,
		context,
	});
}

/**
 * Count Notification お知らせ数の取得
 *
 * Returns number of Notifications.
 */
export function countNotification(
	config: BacklogConfig,
	params?: CountNotificationParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<NotificationCount>> {
	return requestApiGet({
		config,
		path: "notifications/count",
		params,
		context,
	});
}

/**
 * Reset Unread Notification Count お知らせ数の取得
 *
 * Resets unread Notification count.
 */
export function resetUnreadNotificationCount(
	config: BacklogConfig,
	context?: BacklogApiContext,
): Promise<BacklogResponse<NotificationUnreadCount>> {
	return requestApiPost({
		config,
		path: "notifications/markAsRead",
		params: undefined,
		context,
	});
}

/**
 * Changes notifications read. お知らせの既読化
 *
 * Changes notifications read.
 */
export function readNotification(
	config: BacklogConfig,
	params: ReadNotificationParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<BacklogResponseNoContent>> {
	assert(params);
	return requestApiPostNoContent({
		config,
		path: "notifications/:id/markAsRead",
		params,
		context,
	});
}
